<hard-modal
  [title]="'htEdit' | hardTranslate"
  (close)="close()"
  (closeModal)="close()"
>
  @if (loading) {
    <hard-loading></hard-loading>
  } @else {
    <hard-form-grid
      [form]="form"
      [config]="{
        params: {
          direction: 'column',
          fields: fields,
        },
      }"
      class="grid grid-cols-1 gap-4"
    ></hard-form-grid>

    <div class="flex justify-end gap-2 mt-4">
      <hard-button (click)="close()">
        {{ "base.cancel" | hardTranslate }}
      </hard-button>
      <hard-button
        [disabled]="saving"
        (click)="save()"
      >
        {{ "base.save" | hardTranslate }}
      </hard-button>
    </div>
  }
</hard-modal>
